export default __webpack_public_path__ + "static/media/texting_storyset.bb9faf10.svg";